<!--
 * @Description: 
 * @Date: 2020-09-24 20:03:35
-->
<template>
  <div>
    <van-tabs
      v-if="!livingStore.isDesktop"
      class="living-tab"
      v-model="activeIndex"
      :swipe-threshold="1"
      :ellipsis="false"
    >
      <van-tab
        v-for="(item, index) in livingStore.zdyMenuList"
        :key="index"
        :title="item.name"
      ></van-tab>
    </van-tabs>

    <van-tabs
      v-else
      class="living-tab"
      v-model="activeIndex"
      :swipe-threshold="1"
      :ellipsis="false"
    >
      <van-tab
        v-for="(item, index) in PctabLIst"
        :key="index"
        :title="item.name"
      ></van-tab>
    </van-tabs>
  </div>
</template>

<script>
export default {
  name: 'LivingTabs',
  inject: ['livingStore'],
  props: {
    tabs: {
      type: Array,
      default() {
        return [];
      }
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      PctabLIst: [],
      activeIndex: 0
    };
  },

  watch: {
    activeIndex: {
      handler(v) {
        this.$emit('update:activeindex', v);
        this.$store.commit('living/SET_COMMON', {
          field: 'currentZdyMenu',
          value: this.livingStore.zdyMenuList[v]
        });
      },
      immediate: true
    },
    'livingStore.zdyMenuList': {
      immediate: true,
      deep: true,
      handler(v) {
        // 初始数据，livingStore为异步 需要监听初始化
        this.PctabLIst = v.filter(item => item.name != '聊天互动');
      }
    }
  }
};
</script>

<style lang="scss">
@media (max-width: 600px) {
  .living-tab {
    border-top: 0.09rem solid #ededed;
    border-bottom: 0.09rem solid #ededed;
    .van-tabs__wrap {
      height: 0.95rem;
    }
    .van-tabs__nav {
      padding-bottom: 0;
    }
    .van-tabs__line {
      display: none;
    }
    .van-tab__text {
      font-size: 0.37rem;
      color: #666666;
      font-weight: 500;
    }
    .van-tab--active {
      // font-size: ;
      .van-tab__text {
        font-size: 0.48rem;
        color: #000000;
        font-weight: bold;
      }
    }
  }
}
@media (min-width: 600px) {
  .living-tab {
    margin-top: 10px;
    border-top: 1px solid #ebebeb;
    .van-tabs__line {
      display: none;
    }
    .van-tabs__nav {
      padding: 0px;
    }
    .van-tab {
      justify-content: left;
      flex: 0 0 auto !important;
      padding-left: 0px;
    }
    .van-tabs__wrap--scrollable {
      flex: 0 0 auto;
    }
    .van-tab--active {
      justify-content: left;
      flex: 0 0 auto;
      .van-tab__text {
        color: #027cfa;
        line-height: 16px;
      }
    }
  }
}
</style>
